import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const partners = [
  { name: 'Frick', image: '13.Frick_.jpg', url: 'https://www.johnsoncontrols.com/industrial-refrigeration/industrial-refrigeration' },
  { name: 'RoFlo', image: '24.RoFlo_.jpg', url: 'https://www.roflocompressors.com/' },
  { name: 'Ariel', image: '12.Ariel_.jpg', url: 'https://www.arielcorp.com/' },
  { name: 'Howden', image: '18.Howden.jpg', url: 'https://www.howden.com/en-us/home' },
  { name: 'Superior', image: '10.Superior.jpg', url: '#' },
  { name: 'Ajax', image: '11.Ajax_.jpg', url: '#' },
  { name: 'Sullair', image: '14.Sullair.jpg', url: '#' },
  { name: 'GE', image: '15.GE_.jpg', url: '#' },
  { name: 'Gardner Denver', image: '16.GardnerDenver.jpg', url: '#' },
  { name: 'Gemini', image: '17.Gemini.jpg', url: '#' },
  { name: 'Kobelco', image: '19.Kobelco.jpg', url: '#' },
  { name: 'Mayacom', image: '20.Mayacom.jpg', url: '#' },
  { name: 'Quincy', image: '21.Quincy.jpg', url: '#' },
  { name: 'Tamrotor', image: '22.Tamrotor.jpg', url: '#' },
  { name: 'Dresser Rand', image: '23.DresserRand.jpg', url: '#' },
  { name: 'Worthington', image: '25.Worthington.jpg', url: '#' },
  { name: 'Knox', image: '26.Knox_.jpg', url: '#' },
  { name: 'IR', image: '27.IR_.jpg', url: '#' },
  { name: 'TDI', image: '28.TDI_.jpg', url: '#' },
  { name: 'PRQ', image: '29.PRQ_.jpg', url: '#' },
  { name: 'Waukesha', image: '3.-Waukesha.jpg', url: '#' },
  { name: 'Goulds', image: '30.Goulds.jpg', url: '#' },
  { name: 'Corken', image: '31.Corken.jpg', url: '#' },
  { name: 'Deming', image: '32.Deming.jpg', url: '#' },
  { name: 'Dean', image: '33.Dean_.jpg', url: '#' },
  { name: 'Grundfos', image: '34.Grundfos.jpg', url: '#' },
  { name: 'Swagelok', image: '35.Swagelok.jpg', url: '#' },
  { name: 'Texsteam', image: '36.Texsteam.jpg', url: '#' },
  { name: 'Endyn', image: '37.Endyn_.jpg', url: '#' },
  { name: 'Impco', image: '38.Impco_.jpg', url: '#' },
  { name: 'Murphy', image: '39.Murphy.jpg', url: '#' },
  { name: 'Cummins', image: '4.Cummins.jpg', url: '#' },
  { name: 'Garrett', image: '40.Garrett.jpg', url: '#' },
  { name: 'Fisher', image: '41.Fisher.jpg', url: '#' },
  { name: 'GM', image: '42.GM_.jpg', url: '#' },
  { name: 'Cooper Energy', image: '5.CooperEnergy.jpg', url: '#' },
  { name: 'Caterpillar', image: '6.Caterpillar.jpg', url: '#' },
  { name: 'Clark', image: '7.Clark_.jpg', url: '#' },
  { name: 'Arrow', image: '8.Arrow_.jpg', url: '#' },
  { name: 'Baker Hughes', image: '9.BakerHughes.jpg', url: '#' },
];

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title fade-in">
                Welcome to Big Strides Inc
              </h1>
              <h2 className="hero-subtitle fade-in">
                Your Strategic Procurement Partner
              </h2>
              <p className="hero-description fade-in">
                We source critical parts and equipment for the oil & gas industry and deliver expert public procurement services for government projects — ensuring best value, best price, every time.
              </p>
              <div className="hero-buttons fade-in">
                <Link to="/oem-and-channels" className="btn btn-primary">
                  Request a Quote
                </Link>
                <Link to="/contact" className="btn btn-outline">
                  Contact Us
                </Link>
              </div>
            </div>
            <div className="hero-image fade-in">
              <img src="/img/101024.png" alt="Big Strides Inc" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section section">
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              <img src="/img/about-img.jpg" alt="About Big Strides" />
            </div>
            <div className="about-text">
              <h2 className="section-title">About Us</h2>
              <p>
                We specialize in delivering tailored procurement solutions for the oil and gas 
                sector across North America, Africa, Europe, Asia, and Australia, as well as 
                expert public procurement services for government projects. Our deep industry knowledge 
                and global reach allow us to navigate complex supply chains and regulatory 
                landscapes, ensuring our clients receive the best value and best price in every 
                procurement transaction.
              </p>
              <p>
                Whether you are a private oil and gas company seeking reliable sourcing for OEM 
                or aftermarket parts or equipment, or government agencies aiming to add an agile 
                procurement partner to your approved vendor list, our team supports your goals. 
                We combine best-in-class procurement practices, robust supplier networks, and a 
                commitment to transparency to help organizations achieve operational excellence 
                and sustainable growth.
              </p>
              <p>
                To discover how Big Strides Inc can meet your procurement needs, send us a quote 
                request or connect with us through our marketplace channels.
              </p>
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section id="partners" className="partners-section section">
        <div className="container">
          <h2 className="section-title">Our Partners</h2>
          <p className="section-subtitle">
            Trusted by leading companies in the oil and gas industry
          </p>
          <div className="partners-grid">
            {partners.map((partner, index) => (
              <a
                key={index}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-logo"
              >
                <img
                  src={`/img/parts/${partner.image}`}
                  alt={partner.name}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Let us help you find the best procurement solutions for your business.</p>
            <div className="cta-buttons">
              <Link to="/oem-and-channels" className="btn btn-primary">
                Request a Quote
              </Link>
              <Link to="/contact" className="btn btn-outline">
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

